import React from 'react';
import { CtaButton } from './CtaButton';
import { deliverables } from '../data/content';
export function Deliverables() {
  return <section className="w-full bg-cream px-4 py-14 sm:px-6 sm:py-20" data-id="element-94" data-mp="10bw4yw43cv0o">
      <div className="mx-auto max-w-3xl" data-id="element-95" data-mp="1e1zk734jzogm">
        <h2 className="text-center font-display text-[26px] font-extrabold leading-tight tracking-tight text-ink sm:text-4xl" data-id="element-96" data-mp="1e310pn4c935q">
          Cosa riceverai immediatamente dopo l’acquisto
        </h2>

        <ul className="mt-9 space-y-3" data-id="element-97" data-mp="1ny2oofmvnz6q">
          {deliverables.map(item => <li key={item.title} className="flex gap-4 rounded-2xl border border-brand-100 bg-white p-4 sm:p-5" data-id="element-98" data-mp="1j0avliahy70y">
              <span className="text-2xl leading-none" aria-hidden="true" data-id="element-99" data-mp="1sz9wufsxn0dx">
                {item.emoji}
              </span>
              <div data-id="element-100" data-mp="2nm1econpz7g">
                <h3 className="font-display text-[17px] font-bold leading-snug text-ink sm:text-lg" data-id="element-101" data-mp="2n2tzpwmut7o">
                  {item.title}
                </h3>
                <p className="mt-1.5 text-[14px] font-medium leading-relaxed text-inksoft sm:text-[15px]" data-id="element-102" data-mp="3k5dofjhxclro">
                  {item.text}
                </p>
              </div>
            </li>)}
        </ul>

        <div className="mt-10" data-id="element-103" data-mp="3u303q734yfc6">
          <CtaButton label="Voglio ricevere tutto oggi" note="Riceverai l’accesso via email in pochi minuti." data-id="element-104" data-mp="3u1ozk65s35kj" />
        </div>
      </div>
    </section>;
}